var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.component)?_c(_vm.component,{tag:"component",attrs:{"filterData":_vm.filterData,"paginationData":_vm.paginationData}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }